import type { AnswerMap, StaffRole } from './types';
import generatedCatalog from './wordCatalog.generated.json';

export type WordDocumentKind = keyof typeof generatedCatalog;
export type WordDocumentPerson = 'client' | 'spouse';
interface CatalogEntry {
	label: string;
	agents: string;
	mode: string;
	sources: Partial<Record<WordDocumentPerson, string>>;
}
export const WORD_CATALOG: Record<WordDocumentKind, CatalogEntry> = generatedCatalog;
export const WORD_DOCUMENTS = Object.fromEntries(Object.entries(WORD_CATALOG).map(([key, value]) => [key, value.label])) as Record<
	WordDocumentKind,
	string
>;
export function isWordDocumentKind(value: string): value is WordDocumentKind {
	return Object.hasOwn(WORD_CATALOG, value);
}
export function wordUsesTrustName(kind: WordDocumentKind): boolean {
	return kind.startsWith('grantor-') || kind.startsWith('non-grantor-');
}
export function wordChoices(search = ''): WordDocumentKind[] {
	const terms = search.trim().toLocaleLowerCase('en-US').split(/\s+/u).filter(Boolean);
	return (Object.keys(WORD_CATALOG) as WordDocumentKind[])
		.filter((key) => terms.every((term) => WORD_CATALOG[key].label.toLocaleLowerCase('en-US').includes(term)))
		.sort((a, b) => WORD_CATALOG[a].label.localeCompare(WORD_CATALOG[b].label, 'en'));
}
export function wordAllowedPeople(kind: WordDocumentKind): WordDocumentPerson[] {
	const mode = WORD_CATALOG[kind].mode;
	return mode === 'spouse' ? ['spouse'] : mode === 'selected' ? ['client', 'spouse'] : ['client'];
}
export const WORD_DOCUMENT_ROLES = ['administrator', 'attorney', 'intake_staff'] as const satisfies readonly StaffRole[];
export function canUseWordDocuments(role: StaffRole): boolean {
	return WORD_DOCUMENT_ROLES.some((allowed) => allowed === role);
}
export function wordPersonName(answers: AnswerMap, person: WordDocumentPerson): string {
	const value = answers[`${person}.full_name`];
	return typeof value === 'string' ? value.trim() : '';
}
export interface WordDocumentVersion {
	id: string;
	kind: WordDocumentKind;
	person: WordDocumentPerson;
	version: number;
	generatedAt: string;
}
